// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b16c9b75","455":"f9ccab27","977":"c7d6623c"}[chunkId] + ".chunk.js";
};